var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntFormItem',{staticClass:"select"},[_c('label',{attrs:{"for":_vm.name}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('AntSelect',_vm._g(_vm._b({directives:[{name:"decorator",rawName:"v-decorator",value:([_vm.name, {
      initialValue: _vm.initialValue,
      preserve: _vm.preserve,
    }]),expression:"[name, {\n      initialValue,\n      preserve,\n    }]"}],attrs:{"placeholder":_vm.placeholder,"allowClear":""}},'AntSelect',_vm.$attrs,false),_vm.$listeners),[(_vm.options)?_vm._l((_vm.options),function(ref){
    var value = ref.value;
    var label = ref.label;
return _c('AntSelectOption',{key:value},[_vm._v(" "+_vm._s(label)+" ")])}):_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }